import { gql } from 'graphql-tag'
import { continuingChecklistItemFragment } from '../admin/checklist/checklistQueries'

const shiftStatusFragment = gql`
  fragment ShiftStatusFragment on ShiftStatusType {
    morning
    evening
    night
  }
`

export const fetchDailyChecklist = gql`
  query fetchDailyChecklist($stationId: ID!, $date: String!) {
    dailyChecklist(stationId: $stationId, date: $date) {
      id
      description
      type
      shiftStatus {
        ...ShiftStatusFragment
      }
      checklistItemShiftStatus {
        ...ShiftStatusFragment
      }
      checklistItemId
    }
    uncheckedContinuingChecklistItems(stationId: $stationId, date: $date) {
      ...ContinuingChecklistItemFragment
    }
  }
  ${shiftStatusFragment}
  ${continuingChecklistItemFragment}
`

const toiletCheckFragment = gql`
  fragment DailyToiletCheckFragment on DailyToiletCheck {
    id
    date
    status {
      hour
      status
    }
  }
`

export const openingTimeFragment = gql`
  fragment OpeningTimeFragment on OpeningTime {
    id
    weekDay
    startTime
    endTime
  }
`

export const fetchDailyToiletCheck = gql`
  query fetchDailyToiletCheck(
    $stationId: ID!
    $longPeriodDate: String!
    $shortPeriodDate: String!
    $longPeriodWeekday: WeekDay
    $shortPeriodWeekday: WeekDay
  ) {
    longPeriod: dailyToiletCheck(stationId: $stationId, date: $longPeriodDate) {
      ...DailyToiletCheckFragment
    }
    shortPeriod: dailyToiletCheck(stationId: $stationId, date: $shortPeriodDate) {
      ...DailyToiletCheckFragment
    }
    longPeriodOpeningHours: openingTimes(stationId: $stationId, date: $longPeriodDate, weekday: $longPeriodWeekday) {
      ...OpeningTimeFragment
    }
    shortPeriodOpeningHours: openingTimes(stationId: $stationId, date: $shortPeriodDate, weekday: $shortPeriodWeekday) {
      ...OpeningTimeFragment
    }
  }
  ${toiletCheckFragment}
  ${openingTimeFragment}
`

export const upsertDailyChecklist = gql`
  mutation upsertDailyChecklist(
    $checklistItemId: ID!
    $stationId: ID!
    $date: String!
    $shiftStatus: ShiftStatusInputType!
  ) {
    upsertDailyChecklist(
      data: { date: $date, shiftStatus: $shiftStatus, checklistItemId: $checklistItemId }
      stationId: $stationId
    ) {
      id
      date
      shiftStatus {
        ...ShiftStatusFragment
      }
    }
  }
  ${shiftStatusFragment}
`

export const upsertDailyToiletCheck = gql`
  mutation upsertDailyToiletCheck($date: String!, $hour: Int!, $status: Boolean!, $stationId: ID!) {
    upsertDailyToiletCheck(stationId: $stationId, data: { hour: $hour, status: $status, date: $date }) {
      id
      status {
        status
        hour
      }
    }
  }
`

export const fetchToiletCheckQuestion = gql`
  query fetchToiletCheckQuestion($stationId: ID) {
    randomToiletCheckQuestion(stationId: $stationId) {
      id
      description
    }
  }
`

export const markContinuingChecklistItemChecked = gql`
  mutation markContinuingChecklistItemChecked($stationId: ID!, $continuingChecklistItemId: ID!, $date: String!) {
    markContinuingChecklistItemChecked(
      stationId: $stationId
      continuingChecklistItemId: $continuingChecklistItemId
      date: $date
    )
  }
`

export const fetchCheckQuestions = gql`
  query fetchCheckQuestions($stationId: ID) {
    checkQuestions(stationId: $stationId) {
      id
      type
      description
    }
  }
`
